import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminEmployers from "@/pages/AdminEmployers";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/employers")({
  head: () => seoHead("/admin/employers"),
  component: () => (
    <AdminGate><AdminEmployers /></AdminGate>
  ),
});
